import React from 'react';

const RoleAvatar = ({ isEvaluator, label, src }) => {
  const text = label ?? (isEvaluator ? 'E' : 'C');
  return (
    <span
      className={`rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fw-semibold ${
        text.length > 1 ? 'fs-11' : 'fs-12'
      } ${
        isEvaluator
          ? 'bg-primary-subtle text-primary'
          : 'bg-danger-subtle text-danger'
      }`}
      style={{ width: '28px', height: '28px' }}
    >
      {src ? (
        <img
          src={src}
          alt=''
          style={{ width: '16px', height: '16px', objectFit: 'contain' }}
        />
      ) : (
        text
      )}
    </span>
  );
};

const BubbleTail = ({ isEvaluator }) => (
  <span
    aria-hidden
    style={{
      position: 'absolute',
      top: '18px',
      zIndex: 1,
      width: 0,
      height: 0,
      borderTop: '8px solid transparent',
      borderBottom: '8px solid transparent',
      ...(isEvaluator
        ? {
            left: '-8px',
            borderRight: '8px solid var(--bs-primary-bg-subtle)',
          }
        : {
            right: '-8px',
            borderLeft: '8px solid var(--bs-danger-bg-subtle)',
          }),
    }}
  />
);

const RespondMessageBubble = ({
  isEvaluator = false,
  content = '',
  authorLabel = '',
  metaDate = null,
  footer = null,
  avatarLabel,
  avatarSrc,
  roleLabel,
  title = 'Respond Notes',
}) => {
  const metaText = [authorLabel, metaDate].filter(Boolean).join(' · ');
  const badgeLabel = roleLabel ?? (isEvaluator ? 'Evaluator' : 'Counter');

  return (
    <div
      className={`d-flex gap-2 mt-2 ${isEvaluator ? '' : 'flex-row-reverse'}`}
    >
      <RoleAvatar
        isEvaluator={isEvaluator}
        label={avatarLabel}
        src={avatarSrc}
      />
      <div
        className={`d-flex flex-column flex-grow-1 min-w-0 overflow-visible ${
          isEvaluator ? 'align-items-start' : 'align-items-end'
        }`}
        style={{ maxWidth: '85%' }}
      >
        <div
          className={`position-relative w-100 overflow-visible ${
            isEvaluator ? 'ps-1' : 'pe-1'
          }`}
        >
          <BubbleTail isEvaluator={isEvaluator} />
          <div
            className={`p-3 w-100 rounded-3 overflow-hidden ${
              isEvaluator ? 'bg-primary-subtle' : 'bg-danger-subtle'
            }`}
          >
            <div className='d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2'>
              <div className='d-flex align-items-center gap-2'>
                {title ? (
                  <div className='fw-bold text-dark fs-13'>{title}</div>
                ) : null}
                <span
                  className={`badge rounded-pill fs-11 ${
                    isEvaluator ? 'bg-primary' : 'bg-danger'
                  }`}
                >
                  {badgeLabel}
                </span>
              </div>
              {metaText ? (
                <div className='text-muted fs-12'>{metaText}</div>
              ) : null}
            </div>
            <div
              className='text-dark mb-0 fs-13 lh-base'
              dangerouslySetInnerHTML={{ __html: content || '-' }}
            />
            {footer}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RespondMessageBubble;
